import React from "react";
import Card from "../Card/Card";

const StepContainer = ({ step, buttons, children }) => {
    return (
        <Card loading={step.loading} type={step.id}>
            <div className="flex flex-wrap -mx-4 mb-4">
                <div className="w-full lg:w-4/12 px-4 pb-6">
                    <h2 className={`font-head font-bold text-xl mb-1 ${step.done && 'text-blue-400'}`}>
                        {step.done && (<i className="fas text-blue-400 fa-check-circle mr-2"></i>)}{step.description}
                    </h2>
                    {step.step_description && (
                        <p className="mb-4">{step.step_description}</p>
                    )}
                    {buttons}
                </div>
                <div className="w-full lg:w-8/12 px-4 mb-4">{children}</div>
                <div className="w-full px-4">
                    <hr className="mb-12 border-gray-200 border-t-2" />
                </div>
            </div>
        </Card>
    );
};

export default StepContainer;
